module.exports = {"data":{"site":{"siteMetadata":{"title":"The Hack Club Scholarship","description":"Apply for a grant for technology-interested high schoolers in Cincinnati","url":"https://scholarship.hackclub.com","img":"https://scholarship.hackclub.com/metadata.jpg"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 198
// module chunks = 60335399758886 114276838955818